module.exports = __webpack_public_path__ + "static/media/ic_blue_tick.9bfd9517.svg";